/* System defined core library */
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

/* User defined library/components */
import { SelectedExamDetailService } from '../../../scheduling/shared/services/selected-exam-detail.service';
import { TimerService } from '../../services/timer.service';

/* Images */
const searchAvailabilityImg = require('../../../../../Assets/images/SearchAvailability.png');
const scheduleImg = require('../../../../../Assets/images/Schedule.png');
const apptLookupImg = require('../../../../../Assets/images/AppointmentLookup.png');
const rescheduleImg = require('../../../../../Assets/images/Reschedule.png');
const cancelImg = require('../../../../../Assets/images/Cancel.png');

@Component({
  selector: 'home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})

export class HomeComponent implements OnInit {
  public searchAvail = searchAvailabilityImg;
  public schedule = scheduleImg;
  public apptLookup = apptLookupImg;
  public reschedule = rescheduleImg;
  public cancel = cancelImg;
  public errorOnHomePage: boolean = false;
  public sessionExpired: boolean = false;
  translateLanguage$: Subscription;

  /* Constructor declaration with required injected services */
  constructor(
    private router: Router,
    private selectedExamDetailService: SelectedExamDetailService,
    private timerService: TimerService,
    private translate: TranslateService
  ) {

    // this language will be used as a fallback when a translation isn't found in the current language
    translate.setDefaultLang(this.selectedExamDetailService.defaultLanguageCode);
    // the lang to use, if the lang isn't available, it will use the current loader to get them
    this.translateLanguage$ = selectedExamDetailService.languageCode.subscribe(
      languageCode => {
        translate.use(languageCode);
      }
    )
  }

  /* Initialize the component & call require methods when component loaded first time. */
  ngOnInit() {
    this.timerService.clearClock();
    if (!this.selectedExamDetailService.isCompleteApptPath) {
      this.selectedExamDetailService.resetExamService();
    }
    this.errorOnHomePage = this.selectedExamDetailService.errorOnHomePage;
    if (this.errorOnHomePage) this.selectedExamDetailService.skipConfirmPage = false;
    this.sessionExpired = this.selectedExamDetailService.sessionExpired;
  }

  /* Start Find Availability flow */
  navigateToNext(): void {
    this.selectedExamDetailService.currentTargetFlow = "FindAvailability";
    this.selectedExamDetailService.setSelectedAppointmentDetails([]);
    this.router.navigate(['/scheduling/searchAvailability']);
    this.selectedExamDetailService.sessionExpired = false;
  }

  /* Start Appointment Lookup flow */
  navigateToAppointmentlookup(): void {
    this.selectedExamDetailService.currentTargetFlow = "AppointmentLookup";
    this.selectedExamDetailService.isSearchPerformed = false;
    this.selectedExamDetailService.setAppointmentSearch(null);
    this.selectedExamDetailService.setBooking(null);
    this.router.navigate(['/scheduling/appointmentsearch']);
    this.selectedExamDetailService.sessionExpired = false;
  }

  /* Start Schedule flow */
  navigateToAppointmentSchedule(): void {
    this.selectedExamDetailService.currentTargetFlow = "Schedule";
    this.selectedExamDetailService.setSelectedAppointmentDetails([]);
    this.router.navigate(['/scheduling/scheduleappointment']);
    this.selectedExamDetailService.sessionExpired = false;
    this.selectedExamDetailService.doesClientExist = false;
  }

  /* Start Reschedule flow */
  navigateToAppointmentReSchedule(): void {
    this.selectedExamDetailService.currentTargetFlow = "Reschedule";
    this.selectedExamDetailService.isSearchPerformed = false;
    this.selectedExamDetailService.setAppointmentSearch(null);
    this.selectedExamDetailService.setBooking(null);
    this.router.navigate(['/scheduling/rescheduleappointment']);
    this.selectedExamDetailService.sessionExpired = false;
  }

  /* Start Cancellation flow */
  navigateToAppointmentCancellation(): void {
    this.selectedExamDetailService.currentTargetFlow = "Cancellation";
    this.router.navigate(['/scheduling/cancelappointment']);
    this.selectedExamDetailService.sessionExpired = false;
  }
}
